// extracted by mini-css-extract-plugin
module.exports = {"selectedPlanSummary":"uMLjRY","note":"_2obrXB","noteTitle":"_3H5EP1","buttons":"_1cIuCq","button":"_2ZbQyB","attention":"_1n0OBy","shine-lines":"Sra5-0"};